/**
 * Member-facing UI copy, composed from per-domain namespace files.
 *
 * Split (MYN-219) once this file crossed the mnr-standards 600-LOC merge
 * blocker - by domain, following the `admin-strings.ts` precedent. Each
 * sibling `ui-strings.<domain>.ts` owns whole top-level namespaces and stays
 * under the 400-LOC cap. The public shape is unchanged: every existing
 * `UI_STRINGS.<KEY>` access resolves exactly as before.
 */
import { UI_SHELL_STRINGS } from './ui-strings.shell';
import { UI_AUTH_STRINGS } from './ui-strings.auth';
import { UI_STARTUP_STRINGS } from './ui-strings.startup';
import { UI_INVITE_STRINGS } from './ui-strings.invite';
import { UI_ACCOUNT_STRINGS } from './ui-strings.account';
import { UI_INVESTOR_STRINGS } from './ui-strings.investor';
import { UI_SHARED_PROFILE_STRINGS } from './ui-strings.shared-profile';

export const UI_STRINGS = {
  BRAND_NAME: 'My NEXT Raise',
  ...UI_SHELL_STRINGS,
  ...UI_AUTH_STRINGS,
  ...UI_STARTUP_STRINGS,
  ...UI_INVITE_STRINGS,
  ...UI_ACCOUNT_STRINGS,
  ...UI_INVESTOR_STRINGS,
  ...UI_SHARED_PROFILE_STRINGS,
} as const;
